import { useContext } from 'react'

import AuthContext from '@contexts/Auth/AuthContext'
import { usePricingToolPermission } from '@new/domains/finance/screens/PricingTool/utils/permissions'

import { ENG_AND_PRODUCT_EMAILS } from '../constants/emailsList'

/**
 * Revenue Home shares Pricing Tool's access rules (the Pricing Tool allowlist,
 * or anyone holding the backend 'Revenue Management' role), plus the
 * engineering & product team.
 *
 * @public
 */
export const useAnalystHomePermission = (): boolean => {
  const auth = useContext(AuthContext)
  const email = auth.user?.email
  const hasPricingToolPermission = usePricingToolPermission()

  return hasPricingToolPermission || (!!email && ENG_AND_PRODUCT_EMAILS.includes(email))
}
